/* tslint:disable */
import { enableProdMode } from '@angular/core';
import { Environment } from './model';

enableProdMode();

export const environment: Environment = {
  production: true,
  showDevModule: false,
  isDesktopApp: (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer'),
  apiBaseUrl: 'https://www.cambridgeone.org/mobile-gateway/',
  apiDomain: 'https://www.cambridgeone.org',
  userLoginKey: "W9O0lsiJu",
  externalLinksBaseURL: 'https://www.cambridgeone.org/'
};
